// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"5de9ee08","474":"66fe8ee9","635":"78ab7a55","916":"d95a6bba"}[chunkId] + ".chunk.js";
};